import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import {
  ALWAYS_ALLOWED,
  UPLOAD_PATH_PREFIX,
} from '@core/configurations/auth.config';
import { AuthContextService } from '@core/services/auth-context.service';
import { AuthService } from '@core/services/auth.service';

export const uploadOnlyGuard: CanActivateChildFn = async (_route, state) => {
  const router = inject(Router);
  const auth = inject(AuthService);
  const ctx = inject(AuthContextService);

  const url = state.url.split('?')[0];
  if (ALWAYS_ALLOWED.has(url)) return true;

  await ctx.syncSession();

  const mode = ctx.getMode();
  const isUploadOnly = mode === 'upload-files';

  if (!isUploadOnly && url.startsWith(UPLOAD_PATH_PREFIX)) {
    return router.createUrlTree(['/home']);
  }

  if (isUploadOnly) {
    if (!auth.isAuthenticated()) return true;
    if (!url.startsWith(UPLOAD_PATH_PREFIX))
      return router.createUrlTree(['/upload']);
  }

  return true;
};
